import { AppBar } from "@mui/material";
import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";
import { styled } from "@mui/system";

export const HeaderStyles = makeStyles((theme: Theme) =>
  createStyles({
    test: {
      display: "flex",
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
    },
    supportButton: {
      width: "20px",
      height: "40px",
    },
    backButton: {
      paddingBottom: "0px",
    },
    profileButton: {
      paddingLeft: "20px",
      cursor: "pointer",
      marginTop: "8px",
    },
    logoutButton: {
      cursor: "pointer",
    },
    mailButton: {
      cursor: "pointer",
      display: "flex",
    },
    title: {
      fontSize: "26px",
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightBold,
    },
    icon: {
      textAlign: "right",
    },
    container: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      minHeight: "110px",
      padding: "0px 20px 0px 20px",
      border: "none",
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    containerdesktop: {
      height: "70px",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "end",
      textAlign: "center",
      backgroundColor: theme.palette.background.default,
      color: "#000",
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },

    arrowLeft: {
      marginRight: 10,
    },
    addressText: {
      fontSize: 20,
      fontWeight: theme.typography.fontWeightBold,
    },
    notificationContainer: {
      paddingRight: 24,
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "12px",
    },
    badge: {
      color: theme.palette.secondary.main,
    },
    clickable: {
      cursor: "pointer",
    },
    hide: {
      display: "none",
    },
    navLink: {
      marginRight: "1.5rem",
      color: "inherit",
      textDecoration: "none",
    },
    navLinkActive: {
      marginRight: "1.5rem",
      color: "red",
      textDecoration: "black solid 1px",
    },

    tabsContainer: {
      overflow: "visible",

      "& .MuiTab-root": {
        padding: "12px 0 4px 0",
        margin: "0 16px 0 12px",
        minWidth: "auto",
        fontSize: "1rem",
      },

      "& .MuiTabs-scroller": {
        overflow: "visible !important",
      },

      "& .MuiTabs-indicator": {
        bottom: "-11px",
      },
    },
  }),
);

export const DesktopAppbar = styled(AppBar)(({ theme }) => ({
  zIndex: (theme as Theme).zIndex.drawer + 1,
  display: "flex",
  height: "60px",
  padding: "4px 24px",
  justifyContent: "flex-end",
  alignItems: "flex-end",
  gap: "4px",
  backgroundColor: theme.palette.background.default,
  boxShadow: `0px 4px 20px 0px ${
    theme.palette.mode === "light"
      ? "rgba(173, 192, 203, 0.30)"
      : theme.palette.secondary.contrastText
  }`,
}));

export const DesktopAppbarComponents = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flex: "1",
  width: "calc(100% - 220px)",
}));

export const DesktopAppbarButtons = styled("div")(() => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  alignSelf: "stretch",
  gap: "12px",
}));
